"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var PartnersCtxItemImgBack = /** @class */ (function (_super) {
    __extends(PartnersCtxItemImgBack, _super);
    function PartnersCtxItemImgBack(props) {
        return _super.call(this, props) || this;
    }
    PartnersCtxItemImgBack.prototype.componentWillMount = function () {
        this.setState({
            bgColor: "#FFFFFF",
        });
    };
    PartnersCtxItemImgBack.prototype.onMouseEnter = function () {
        this.setState({
            bgColor: "#89CFF0",
        });
    };
    PartnersCtxItemImgBack.prototype.onMouseLeave = function () {
        this.setState({
            bgColor: "#FFFFFF",
        });
    };
    PartnersCtxItemImgBack.prototype.buttonClick = function () {
        if (this.props.onBackClick) {
            this.props.onBackClick(this.props.brandId);
        }
    };
    PartnersCtxItemImgBack.prototype.render = function () {
        var cssStyle = {
            borderColor: "black",
            borderStyle: "solid",
            borderLeftWidth: "1px",
            borderTopWidth: "1px",
            borderRightWidth: "1px",
            borderBottomWidth: "1px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            width: "160px",
            height: "160px",
            marginLeft: "5px",
            marginTop: "5px",
            marginRight: "0px",
            marginBottom: "5px",
            backgroundColor: this.state.bgColor,
            cursor: "pointer",
            position: "relative"
        };
        return (React.createElement("div", { style: cssStyle, onMouseEnter: this.onMouseEnter.bind(this), onMouseLeave: this.onMouseLeave.bind(this), onClick: this.buttonClick.bind(this) },
            React.createElement(antd_1.Icon, { type: "home", style: { fontSize: "42px" } }),
            React.createElement("div", { style: { overflow: "hidden", textOverflow: "ellipsis" } }, this.props.title)));
    };
    return PartnersCtxItemImgBack;
}(React.Component));
exports.default = PartnersCtxItemImgBack;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_images/ui/component/controls/PartnersCtxItemImgBack.tsx
// module id = 2466
// module chunks = 0